import i18n from '@/i18n/i18n'
import LateFeeInterestService from '@/services/admin/LateFeeInterestService.js'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedSorts = '-created_at'
export const allowedFilters = []
export const allowedIncludes = null
export const allowedAppends = null

export const state = {
  lateFeeInterests: [],
  lateFeeInterest: {},
  meta: null
}

export const mutations = {
  SET_LATE_FEE_INTERESTS(state, lateFeeInterests) {
    state.lateFeeInterests = lateFeeInterests.data
    state.meta = lateFeeInterests.meta
  },
  ADD_LATE_FEE_INTEREST(state, lateFeeInterest) {
    state.lateFeeInterests.push(lateFeeInterest)
  }
}

export const actions = {
  getLateFeeInterests({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)

    return new Promise((resolve, reject) => {
      LateFeeInterestService.getLateFeeInterests(newQuery)
        .then(response => {
          commit('SET_LATE_FEE_INTERESTS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createLateFeeInterest({ commit, dispatch, state }, lateFeeInterest) {
    return new Promise((resolve, reject) => {
      LateFeeInterestService.createLateFeeInterest(lateFeeInterest)
        .then(response => {
          commit('ADD_LATE_FEE_INTEREST', response.data)
          const notification = {
            type: 'success',
            message: t('store.shared.save', {
              element: t('store.admin.base_interest_rate.base_interest_rate')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.not_added', {
              element: t('store.admin.base_interest_rate.base_interest_rate')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
